export const BLOCKED_IT_VAT_IDS = ['IT02616790214', 'IT01342330212', 'IT01621460227', 'IT01389380211'];
